import React, { useEffect } from "react";
import {
  Card,
  Button,
  Spin,
  Flex,
  Alert,
  Slider,
  Switch,
  InputNumber,
} from "antd";
import {
  QuestionCircleOutlined,
  MenuOutlined,
  DashboardOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import {
  useFetchOneTemperatureDataQuery,
  useFetchSensorDataMutation,
} from "./temperature.service";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "./style.css";

const TemperatureView = () => {
  const { t } = useTranslation();

  const tempType = useSelector((store) => store.temperature.temperatureType);

  const navigate = useNavigate();
  const { id: uid } = useParams();
  const {
    data: fetchData = { data: {} },
    isLoading,
    isSuccess,
  } = useFetchOneTemperatureDataQuery(uid);

  const [requestFetchSensorData, { data: sensorData = { data: [] } }] =
    useFetchSensorDataMutation();

  const { data } = fetchData;
  const { data: sensor } = sensorData;

  useEffect(() => {
    if (data.dev_eui) requestFetchSensorData(data.dev_eui);
  }, [data]);

  if (isLoading)
    return (
      <Flex justify="center" align="center">
        <Spin />
      </Flex>
    );
  return (
    <Card bordered={false} className="temperature-view-page">
      <div className="temperature-view-page-container">
        <Alert
          message={
            <div className="temperature-view-page-container-alert">
              <div className="temperature-view-page-container-alert-header">
                <div className="temperature-view-page-container-alert-header-devinfo">
                  {data.dev_eui}
                  <QuestionCircleOutlined
                    style={{ marginLeft: "10px", color: "#5caa76" }}
                  />
                </div>
                <div className="temperature-view-page-container-alert-header-devstatus">
                  {sensor?.battery}%
                  <MenuOutlined
                    style={{ marginLeft: "10px", color: "#5caa76" }}
                  />
                </div>
              </div>
              <div className="temperature-view-page-container-alert-content">
                <DashboardOutlined style={{ color: "#5caa76" }} />
                <h1 style={{ color: "#100450" }}>
                  {sensor?.temperature
                    ? tempType === "celsius"
                      ? `${sensor?.temperature} °C`
                      : `${((sensor?.temperature * 9) / 5 + 32).toFixed(2)} °F`
                    : ""}
                </h1>
              </div>
              <div className="temperature-view-page-container-alert-footer">{`Last updated ${moment(
                sensor[0]?.createdAt
              ).format("MMM D, YYYY h:mm a")}`}</div>
            </div>
          }
          type="info"
        />
        <div className="temperature-view-page-container-setting">
          <div className="temperature-view-page-container-setting-alerting">
            <div className="temperature-view-page-container-setting-alerting-label">
              {t("Temp Alerting")}
            </div>
            <Switch value={data.alert} />
          </div>
          <div className="temperature-view-page-container-setting-slider">
            <div className="temperature-view-page-container-setting-slider-control">
              {t("Min")}
              <Slider
                max={100}
                min={-100}
                range
                tooltip={{
                  formatter: (value) =>
                    `${value}${tempType === "celsius" ? "°C" : "°F"}`,
                }}
                defaultValue={[
                  tempType === "celsius"
                    ? data.min_temp
                    : ((data.min_temp * 9) / 5 + 32).toFixed(2),
                  tempType === "celsius"
                    ? data.max_temp
                    : ((data.max_temp * 9) / 5 + 32).toFixed(2),
                ]}
              />
              {t("Max")}
            </div>
            <div className="temperature-view-page-container-setting-slider-view">
              <div className="temperature-view-page-container-setting-slider-view-min">
                <InputNumber
                  value={
                    tempType === "celsius"
                      ? data.min_temp
                      : ((data.min_temp * 9) / 5 + 32).toFixed(2)
                  }
                  formatter={(value) =>
                    `${value} ${tempType === "celsius" ? "°C" : "°F"}`
                  }
                  parser={(value) =>
                    tempType === "celsius"
                      ? value?.replace(" °C", "")
                      : value?.replace(" °F", "")
                  }
                />
              </div>
              <div className="temperature-view-page-container-setting-slider-view-max">
                <InputNumber
                  value={
                    tempType === "celsius"
                      ? data.max_temp
                      : ((data.max_temp * 9) / 5 + 32).toFixed(2)
                  }
                  formatter={(value) =>
                    `${value} ${tempType === "celsius" ? "°C" : "°F"}`
                  }
                  parser={(value) =>
                    tempType === "celsius"
                      ? value?.replace(" °C", "")
                      : value?.replace(" °F", "")
                  }
                />
              </div>
            </div>
          </div>
          <div className="temperature-view-page-container-setting-delay">
            <div className="temperature-view-page-container-setting-delay-label">
              {t("Delay before alert")}
            </div>
            <div className="temperature-view-page-container-setting-delay-value">
              {data.delay_before_alert} {t(data.delay_unit)}
            </div>
          </div>
        </div>
      </div>
      <div className="temperature-view-page-footer">
        <Button type="default" onClick={() => navigate("/temperatures")}>
          {t("Close")}
        </Button>
      </div>
    </Card>
  );
};

export default TemperatureView;
